// extracted by mini-css-extract-plugin
var _1 = "YxvlWXRR9e26_SRfGNH_";
var _2 = "uZlblRPh3D5f9Vpz9YC5";
var _3 = "JuiyYA_xv4PkXmM9crdL";
export { _1 as "item", _2 as "number", _3 as "title" }
